const statesList = [
        {
          "code": "AB",
          "name": "Abia",
          "subdivision": [
            "Aba North",
            "Aba South",
            "Arochukwu",
            "Bende",
            "Ikwuano",
            "Isiala-Ngwa North",
            "Isiala-Ngwa South",
            "Isuikwato",
            "Obi Nwa",
            "Ohafia",
            "Osisioma",
            "Ngwa",
            "Ugwunagbo",
            "Ukwa East",
            "Ukwa West",
            "Umuahia North",
            "Umuahia South",
            "Umu-Neochi"
          ]
        },
        {
          "code": "FC",
          "name": "Abuja",
          //"name": "Abuja Federal Capital Territory",
          "subdivision": [
            "Abaji",
            "Abuja Municipal",
            "Bwari",
            "Gwagwalada",
            "Kuje",
            "Kwali"
          ]
        },
        {
          "code": "AD",
          "name": "Adamawa",
          "subdivision": [
            "Demsa",
            "Fufore",
            "Ganaye",
            "Gireri",
            "Gombi",
            "Guyuk",
            "Hong",
            "Jada",
            "Lamurde",
            "Madagali",
            "Maiha",
            "Mayo-Belwa",
            "Michika",
            "Mubi North",
            "Mubi South",
            "Numan",
            "Shelleng",
            "Song",
            "Toungo",
            "Yola North",
            "Yola South"
          ]
        },
        {
          "code": "AK",
          "name": "Akwa Ibom",
          "subdivision": [
            "Abak",
            "Eastern Obolo",
            "Eket",
            "Esit Eket",
            "Essien Udim",
            "Etim Ekpo",
            "Etinan",
            "Ibeno",
            "Ibesikpo Asutan",
            "Ibiono Ibom",
            "Ika",
            "Ikono",
            "Ikot Abasi",
            "Ikot Ekpene",
            "Ini",
            "Itu",
            "Mbo",
            "Mkpat Enin",
            "Nsit Atai",
            "Nsit Ibom",
            "Nsit Ubium",
            "Obot Akara",
            "Okobo",
            "Onna",
            "Oron",
            "Oruk Anam",
            "Udung Uko",
            "Ukanafun",
            "Uruan",
            "Urue-Offong/Oruko ",
            "Uyo"
          ]
        },
        {
          "code": "AN",
          "name": "Anambra",
          "subdivision": [
            "Aguata",
            "Anambra East",
            "Anambra West",
            "Anaocha",
            "Awka North",
            "Awka South",
            "Ayamelum",
            "Dunukofia",
            "Ekwusigo",
            "Idemili North",
            "Idemili south",
            "Ihiala",
            "Njikoka",
            "Nnewi North",
            "Nnewi South",
            "Ogbaru",
            "Onitsha North",
            "Onitsha South",
            "Orumba North",
            "Orumba South",
            "Oyi"
          ]
        },
        {
          "code": "BA",
          "name": "Bauchi",
          "subdivision": [
            "Alkaleri",
            "Bauchi",
            "Bogoro",
            "Damban",
            "Darazo",
            "Dass",
            "Ganjuwa",
            "Giade",
            "Itas/Gadau",
            "Jama'are",
            "Katagum",
            "Kirfi",
            "Misau",
            "Ningi",
            "Shira",
            "Tafawa-Balewa",
            "Toro",
            "Warji",
            "Zaki"
          ]
        },
        {
          "code": "BY",
          "name": "Bayelsa",
          "subdivision": [
            "Brass",
            "Ekeremor",
            "Kolokuma/Opokuma",
            "Nembe",
            "Ogbia",
            "Sagbama",
            "Southern Jaw",
            "Yenegoa"
          ]
        },
        {
          "code": "BE",
          "name": "Benue",
          "subdivision": [
            "Ado",
            "Agatu",
            "Apa",
            "Buruku",
            "Gboko",
            "Guma",
            "Gwer East",
            "Gwer West",
            "Katsina-Ala",
            "Konshisha",
            "Kwande",
            "Logo",
            "Makurdi",
            "Obi",
            "Ogbadibo",
            "Oju",
            "Okpokwu",
            "Ohimini",
            "Oturkpo",
            "Tarka",
            "Ukum",
            "Ushongo",
            "Vandeikya"
          ]
        },
        {
          "code": "BO",
          "name": "Borno",
          "subdivision": [
            "Abadam",
            "Askira/Uba",
            "Bama",
            "Bayo",
            "Biu",
            "Chibok",
            "Damboa",
            "Dikwa",
            "Gubio",
            "Guzamala",
            "Gwoza",
            "Hawul",
            "Jere",
            "Kaga",
            "Kala/Balge",
            "Konduga",
            "Kukawa",
            "Kwaya Kusar",
            "Mafa",
            "Magumeri",
            "Maiduguri",
            "Marte",
            "Mobbar",
            "Monguno",
            "Ngala",
            "Nganzai",
            "Shani"
          ]
        },
        {
          "code": "CR",
          "name": "Cross River",
          "subdivision": [
            "Akpabuyo",
            "Odukpani",
            "Akamkpa",
            "Biase",
            "Abi",
            "Ikom",
            "Yarkur",
            "Odubra",
            "Boki",
            "Ogoja",
            "Yala",
            "Obanliku",
            "Obudu",
            "Calabar South",
            "Etung",
            "Bekwara",
            "Bakassi",
            "Calabar Municipality"
          ]
        },
        {
          "code": "DE",
          "name": "Delta",
          "subdivision": [
            "Oshimili",
            "Aniocha",
            "Aniocha South",
            "Ika South",
            "Ika North-East",
            "Ndokwa West",
            "Ndokwa East",
            "Isoko south",
            "Isoko North",
            "Bomadi",
            "Burutu",
            "Ughelli South",
            "Ughelli North",
            "Ethiope West",
            "Ethiope East",
            "Sapele",
            "Okpe",
            "Warri North",
            "Warri South",
            "Uvwie",
            "Udu",
            "Warri Central",
            "Ukwani",
            "Oshimili North",
            "Patani"
          ]
        },
        {
          "code": "EB",
          "name": "Ebonyi",
          "subdivision": [
            "Edda",
            "Afikpo",
            "Onicha",
            "Ohaozara",
            "Abakaliki",
            "Ishielu",
            "lkwo",
            "Ezza",
            "Ezza South",
            "Ohaukwu",
            "Ebonyi",
            "Ivo"
          ]
        },
        {
          "code": "ED",
          "name": "Edo",
          "subdivision": [
            "Esan North-East",
            "Esan Central",
            "Esan West",
            "Egor",
            "Ukpoba",
            "Central",
            "Etsako Central",
            "Igueben",
            "Oredo",
            "Ovia SouthWest",
            "Ovia South-East",
            "Orhionwon",
            "Uhunmwonde",
            "Etsako East",
            "Esan South-East"
          ]
        },
        {
          "code": "EK",
          "name": "Ekiti",
          "subdivision": [
            "Ado",
            "Ekiti-East",
            "Ekiti-West",
            "Emure/Ise/Orun",
            "Ekiti South-West",
            "Ikere",
            "Irepodun",
            "Ijero,",
            "Ido/Osi",
            "Oye",
            "Ikole",
            "Moba",
            "Gbonyin",
            "Efon",
            "Ise/Orun",
            "Ilejemeje."
          ]
        },
        {
          "code": "EN",
          "name": "Enugu",
          "subdivision": [
            "Enugu South,",
            "Igbo-Eze South",
            "Enugu North",
            "Nkanu",
            "Udi Agwu",
            "Oji-River",
            "Ezeagu",
            "IgboEze North",
            "Isi-Uzo",
            "Nsukka",
            "Igbo-Ekiti",
            "Uzo-Uwani",
            "Enugu Eas",
            "Aninri",
            "Nkanu East",
            "Udenu."
          ]
        },
        {
          "code": "GO",
          "name": "Gombe",
          "subdivision": [
            "Akko",
            "Balanga",
            "Billiri",
            "Dukku",
            "Kaltungo",
            "Kwami",
            "Shomgom",
            "Funakaye",
            "Gombe",
            "Nafada/Bajoga",
            "Yamaltu/Delta."
          ]
        },
        {
          "code": "IM",
          "name": "Imo",
          "subdivision": [
            "Aboh-Mbaise",
            "Ahiazu-Mbaise",
            "Ehime-Mbano",
            "Ezinihitte",
            "Ideato North",
            "Ideato South",
            "Ihitte/Uboma",
            "Ikeduru",
            "Isiala Mbano",
            "Isu",
            "Mbaitoli",
            "Mbaitoli",
            "Ngor-Okpala",
            "Njaba",
            "Nwangele",
            "Nkwerre",
            "Obowo",
            "Oguta",
            "Ohaji/Egbema",
            "Okigwe",
            "Orlu",
            "Orsu",
            "Oru East",
            "Oru West",
            "Owerri-Municipal",
            "Owerri North",
            "Owerri West"
          ]
        },
        {
          "code": "JI",
          "name": "Jigawa",
          "subdivision": [
            "Auyo",
            "Babura",
            "Birni Kudu",
            "Biriniwa",
            "Buji",
            "Dutse",
            "Gagarawa",
            "Garki",
            "Gumel",
            "Guri",
            "Gwaram",
            "Gwiwa",
            "Hadejia",
            "Jahun",
            "Kafin Hausa",
            "Kaugama Kazaure",
            "Kiri Kasamma",
            "Kiyawa",
            "Maigatari",
            "Malam Madori",
            "Miga",
            "Ringim",
            "Roni",
            "Sule-Tankarkar",
            "Taura",
            "Yankwashi"
          ]
        },
        {
          "code": "KD",
          "name": "Kaduna",
          "subdivision": [
            "Birni-Gwari",
            "Chikun",
            "Giwa",
            "Igabi",
            "Ikara",
            "jaba",
            "Jema'a",
            "Kachia",
            "Kaduna North",
            "Kaduna South",
            "Kagarko",
            "Kajuru",
            "Kaura",
            "Kauru",
            "Kubau",
            "Kudan",
            "Lere",
            "Makarfi",
            "Sabon-Gari",
            "Sanga",
            "Soba",
            "Zango-Kataf",
            "Zaria"
          ]
        },
        {
          "code": "KN",
          "name": "Kano",
          "subdivision": [
            "Ajingi",
            "Albasu",
            "Bagwai",
            "Bebeji",
            "Bichi",
            "Bunkure",
            "Dala",
            "Dambatta",
            "Dawakin Kudu",
            "Dawakin Tofa",
            "Doguwa",
            "Fagge",
            "Gabasawa",
            "Garko",
            "Garum",
            "Mallam",
            "Gaya",
            "Gezawa",
            "Gwale",
            "Gwarzo",
            "Kabo",
            "Kano Municipal",
            "Karaye",
            "Kibiya",
            "Kiru",
            "kumbotso",
            "Ghari",
            "Kura",
            "Madobi",
            "Makoda",
            "Minjibir",
            "Nasarawa",
            "Rano",
            "Rimin Gado",
            "Rogo",
            "Shanono",
            "Sumaila",
            "Takali",
            "Tarauni",
            "Tofa",
            "Tsanyawa",
            "Tudun Wada",
            "Ungogo",
            "Warawa",
            "Wudil"
          ]
        },
        {
          "code": "KT",
          "name": "Katsina",
          "subdivision": [
            "Bakori",
            "Batagarawa",
            "Batsari",
            "Baure",
            "Bindawa",
            "Charanchi",
            "Dandume",
            "Danja",
            "Dan Musa",
            "Daura",
            "Dutsi",
            "Dutsin-Ma",
            "Faskari",
            "Funtua",
            "Ingawa",
            "Jibia",
            "Kafur",
            "Kaita",
            "Kankara",
            "Kankia",
            "Katsina",
            "Kurfi",
            "Kusada",
            "Mai'Adua",
            "Malumfashi",
            "Mani",
            "Mashi",
            "Matazuu",
            "Musawa",
            "Rimi",
            "Sabuwa",
            "Safana",
            "Sandamu",
            "Zango"
          ]
        },
        {
          "code": "KE",
          "name": "Kebbi",
          "subdivision": [
            "Aleiro",
            "Arewa-Dandi",
            "Argungu",
            "Augie",
            "Bagudo",
            "Birnin Kebbi",
            "Bunza",
            "Dandi",
            "Fakai",
            "Gwandu",
            "Jega",
            "Kalgo",
            "Koko/Besse",
            "Maiyama",
            "Ngaski",
            "Sakaba",
            "Shanga",
            "Suru",
            "Wasagu/Danko",
            "Yauri",
            "Zuru"
          ]
        },
        {
          "code": "KO",
          "name": "Kogi",
          "subdivision": [
            "Adavi",
            "Ajaokuta",
            "Ankpa",
            "Bassa",
            "Dekina",
            "Ibaji",
            "Idah",
            "Igalamela-Odolu",
            "Ijumu",
            "Kabba/Bunu",
            "Kogi",
            "Lokoja",
            "Mopa-Muro",
            "Ofu",
            "Ogori/Mangongo",
            "Okehi",
            "Okene",
            "Olamabolo",
            "Omala",
            "Yagba East",
            "Yagba West"
          ]
        },
        {
          "code": "KW",
          "name": "Kwara",
          "subdivision": [
            "Asa",
            "Baruten",
            "Edu",
            "Ekiti",
            "Ifelodun",
            "Ilorin East",
            "Ilorin West",
            "Irepodun",
            "Isin",
            "Kaiama",
            "Moro",
            "Offa",
            "Oke-Ero",
            "Oyun",
            "Pategi"
          ]
        },
        {
          "code": "LA",
          "name": "Lagos",
          "subdivision": [
            "Agege",
            "Ajeromi-Ifelodun",
            "Alimosho",
            "Amuwo-Odofin",
            "Apapa",
            "Badagry",
            "Epe",
            "Eti-Osa",
            "Ibeju/Lekki",
            "Ifako-Ijaye",
            "Ikeja",
            "Ikorodu",
            "Kosofe",
            "Lagos Island",
            "Lagos Mainland",
            "Mushin",
            "Ojo",
            "Oshodi-Isolo",
            "Shomolu",
            "Surulere"
          ]
        },
        {
          "code": "NA",
          "name": "Nassarawa",
          "subdivision": [
            "Akwanga",
            "Awe",
            "Doma",
            "Karu",
            "Keana",
            "Keffi",
            "Kokona",
            "Lafia",
            "Nasarawa",
            "Nasarawa-Eggon",
            "Obi",
            "Toto",
            "Wamba"
          ]
        },
        {
          "code": "NI",
          "name": "Niger",
          "subdivision": [
            "Agaie",
            "Agwara",
            "Bida",
            "Borgu",
            "Bosso",
            "Chanchaga",
            "Edati",
            "Gbako",
            "Gurara",
            "Katcha",
            "Kontagora",
            "Lapai",
            "Lavun",
            "Magama",
            "Mariga",
            "Mashegu",
            "Mokwa",
            "Muya",
            "Pailoro",
            "Rafi",
            "Rijau",
            "Shiroro",
            "Suleja",
            "Tafa",
            "Wushishi"
          ]
        },
        {
          "code": "OG",
          "name": "Ogun",
          "subdivision": [
            "Abeokuta North",
            "Abeokuta South",
            "Ado-Odo/Ota",
            "Yewa North",
            "Yewa South",
            "Ewekoro",
            "Ifo",
            "Ijebu East",
            "Ijebu North",
            "Ijebu North East",
            "Ijebu Ode",
            "Ikenne",
            "Imeko-Afon",
            "Ipokia",
            "Obafemi-Owode",
            "Ogun Waterside",
            "Odeda",
            "Odogbolu",
            "Remo North",
            "Shagamu"
          ]
        },
        {
          "code": "ON",
          "name": "Ondo",
          "subdivision": [
            "Akoko North East",
            "Akoko North West",
            "Akoko South Akure East",
            "Akoko South West",
            "Akure North",
            "Akure South",
            "Ese-Odo",
            "Idanre",
            "Ifedore",
            "Ilaje",
            "Ile-Oluji",
            "Okeigbo",
            "Irele",
            "Odigbo",
            "Okitipupa",
            "Ondo East",
            "Ondo West",
            "Ose",
            "Owo"
          ]
        },
        {
          "code": "OS",
          "name": "Osun",
          "subdivision": [
            "Aiyedade",
            "Aiyedire",
            "Atakumosa East",
            "Atakumosa West",
            "Boluwaduro",
            "Boripe",
            "Ede North",
            "Ede South",
            "Egbedore",
            "Ejigbo",
            "Ife Central",
            "Ife East",
            "Ife North",
            "Ife South",
            "Ifedayo",
            "Ifelodun",
            "Ila",
            "Ilesha East",
            "Ilesha West",
            "Irepodun",
            "Irewole",
            "Isokan",
            "Iwo",
            "Obokun",
            "Odo-Otin",
            "Ola-Oluwa",
            "Olorunda",
            "Oriade",
            "Orolu",
            "Osogbo"
          ]
        },
        {
          "code": "OY",
          "name": "Oyo",
          "subdivision": [
            "Afijio",
            "Akinyele",
            "Atiba",
            "Atisbo",
            "Egbeda",
            "Ibadan Central",
            "Ibadan North",
            "Ibadan North West",
            "Ibadan South East",
            "Ibadan South West",
            "Ibarapa Central",
            "Ibarapa East",
            "Ibarapa North",
            "Ido",
            "Irepo",
            "Iseyin",
            "Itesiwaju",
            "Iwajowa",
            "Kajola",
            "Lagelu Ogbomosho North",
            "Ogbomosho South",
            "Ogo Oluwa",
            "Olorunsogo",
            "Oluyole",
            "Ona-Ara",
            "Orelope",
            "Ori Ire",
            "Oyo East",
            "Oyo West",
            "Saki East",
            "Saki West",
            "Surulere"
          ]
        },
        {
          "code": "PL",
          "name": "Plateau",
          "subdivision": [
            "Barikin Ladi",
            "Bassa",
            "Bokkos",
            "Jos East",
            "Jos North",
            "Jos South",
            "Kanam",
            "Kanke",
            "Langtang North",
            "Langtang South",
            "Mangu",
            "Mikang",
            "Pankshin",
            "Qua'an Pan",
            "Riyom",
            "Shendam",
            "Wase"
          ]
        },
        {
          "code": "RI",
          "name": "Rivers",
          "subdivision": [
            "Abua/Odual",
            "Ahoada East",
            "Ahoada West",
            "Akuku Toru",
            "Andoni",
            "Asari-Toru",
            "Bonny",
            "Degema",
            "Emohua",
            "Eleme",
            "Etche",
            "Gokana",
            "Ikwerre",
            "Khana",
            "Obio/Akpor",
            "Ogba/Egbema/Ndoni",
            "Ogu/Bolo",
            "Okrika",
            "Omumma",
            "Opobo/Nkoro",
            "Oyigbo",
            "Port-Harcourt",
            "Tai"
          ]
        },
        {
          "code": "SO",
          "name": "Sokoto",
          "subdivision": [
            "Binji",
            "Bodinga",
            "Dange-shnsi",
            "Gada",
            "Goronyo",
            "Gudu",
            "Gawabawa",
            "Illela",
            "Isa",
            "Kware",
            "kebbe",
            "Rabah",
            "Sabon birni",
            "Shagari",
            "Silame",
            "Sokoto North",
            "Sokoto South",
            "Tambuwal",
            "Tqngaza",
            "Tureta",
            "Wamako",
            "Wurno",
            "Yabo"
          ]
        },
        {
          "code": "TA",
          "name": "Taraba",
          "subdivision": [
            "Ardo-kola",
            "Bali",
            "Donga",
            "Gashaka",
            "Cassol",
            "Ibi",
            "Jalingo",
            "Karin-Lamido",
            "Kurmi",
            "Lau",
            "Sardauna",
            "Takum",
            "Ussa",
            "Wukari",
            "Yorro",
            "Zing"
          ]
        },
        {
          "code": "YO",
          "name": "Yobe",
          "subdivision": [
            "Bade",
            "Bursari",
            "Damaturu",
            "Fika",
            "Fune",
            "Geidam",
            "Gujba",
            "Gulani",
            "Jakusko",
            "Karasuwa",
            "Karawa",
            "Machina",
            "Nangere",
            "Nguru Potiskum",
            "Tarmua",
            "Yunusari",
            "Yusufari"
          ]
        },
        {
          "code": "ZA",
          "name": "Zamfara",
          "subdivision": [
            "Anka",
            "Bakura",
            "Birnin Magaji",
            "Bukkuyum",
            "Bungudu",
            "Gummi",
            "Gusau",
            "Kaura",
            "Namoda",
            "Maradun",
            "Maru",
            "Shinkafi",
            "Talata Mafara",
            "Tsafe",
            "Zurmi"
          ]
        }
      ];

export default statesList;